export default __webpack_public_path__ + "static/media/external_link_icon.eabe6a6a.svg";